import React, { useState, useEffect } from "react";
import { Card, Row, Col, Statistic, Spin, Divider, Alert, Icon } from "antd";

import CilynderModel from "../../services/cylinder_model";

import { secons2Dhm } from "../../services/timeFunctions";

import { marksAgitation } from "../../constants"

import colors from "../../theme/colors"


//import multilanguage library
import { useTranslation } from 'react-i18next'

// Styles
import { Label, FormItem, LabelValue, LabelUnit } from "./styles";


const Recommendations = ({ article, process, recommendation, handleChangeRecommendation }) => {
  const [furnaceErr, setFurnaceErr] = useState(null);
  const [quenchingErr, setQuenchingErr] = useState(null);
  const [temperedErr, setTemperedErr] = useState(null);
  const [isSubmittingHeating, setIsSubmittingHeating] = useState(false);
  const [isSubmittingKirkaldy, setIsSubmittingKirkaldy] = useState(false);
  const [isSubmittingTempered, setIsSubmittingTempered] = useState(false);

  //To translate text
  const { t } = useTranslation();

  //Habilitar para la demo
  useEffect(() => {
    if (article.selected_figure === "cylinder") {
      const { ModelHeating, ModelKirkaldy, ModelTempered } = CilynderModel();
      setIsSubmittingHeating(true);
      setIsSubmittingKirkaldy(true);
      setIsSubmittingTempered(true);

      ModelHeating(process.furnace.temperature, process.furnace.heating_ramp, article.figure[0].values.radius * 2)
        .then(a => {
          const newRecomendation = {};
          newRecomendation.furnace_time = a.data.runModeloCalentamiento.TiempoOptimoHorno;
          handleChangeRecommendation(newRecomendation);
          if (a.data.runModeloCalentamiento.error) setFurnaceErr(a.data.runModeloCalentamiento.error);
        })
        .catch(e => console.log(e))
        .finally(() => setIsSubmittingHeating(false));


      ModelKirkaldy(
        process.quenching.bath_temperature,
        process.furnace.temperature,
        article.figure[0].values.radius * 2,
        process.quenching.bath_type === "water" ? 1 : 0,
        process.quenching.agitation_level,
        article.hard_coat
      )
        .then(a => {
          const newRecomendation = {};
          newRecomendation.quenching = a.data.runModeloKirkaldy.Espesor;
          handleChangeRecommendation(newRecomendation);
          if (a.data.runModeloKirkaldy.error) setQuenchingErr(a.data.runModeloKirkaldy.error);
        })
        .catch(e => console.log(e))
        .finally(() => setIsSubmittingKirkaldy(false));


        ModelTempered(process.tempered.temperature, process.tempered.heating_ramp, article.figure[0].values.radius * 2, process.tempered.enabled_ramp)
        .then(a => {
          const newRecomendation = {};
          newRecomendation.tempered_time = a.data.runModeloRevenidoCilindro.TiempoOptimoHorno;
          handleChangeRecommendation(newRecomendation);
          if (a.data.runModeloRevenidoCilindro.error) setTemperedErr(a.data.runModeloRevenidoCilindro.error);
        })
        .catch(e => console.log(e))
        .finally(() => setIsSubmittingTempered(false));
    }
  }, [article, process]);

  const RenderData = ({ label, value, unit }) => (
    <Row type="flex" align="middle" justify="space-between" style={{ margin: 0 }}>
      <Col>
        <FormItem>
          <Label>{label}</Label>
        </FormItem>
      </Col>
      <Col>
        {/*<Input value={value ? value : 0} style={{ verticalAlign: "middle", width: "150px" }} readOnly suffix={unit} />*/}
        <LabelValue>{value} </LabelValue>
        <LabelUnit>{unit}</LabelUnit>
      </Col>
    </Row>
  );

  return (
    <Row style={{ margin: 0 }} gutter={[16, 16]}>
      <Col xl={8} lg={24}>
        <Spin spinning={isSubmittingHeating}>
          <Card title={t('phase.furnace')}>
            <Col span={24}>
              <RenderData label={t('labels.furnace.furnace_temp')} value={process.furnace.temperature} unit="ºC" />
            </Col>
            <Col span={24}>
              {process.furnace.enabled_ramp ? (
                <RenderData label={t('labels.furnace.heating_ramp')} value={process.furnace.heating_ramp} unit="ºC/h" />
              ) : (
                <RenderData label={t('labels.furnace.heating_ramp')} value={t('labels.no_ramp')} />
              )}
            </Col>
            <Col span={24}>
              <RenderData label={t('labels.temperature_piece')} value={process.furnace.piece_temperrature} unit="ºC" />
            </Col>

            <Col span={24}>
              <Divider style={{ fontSize: 12, fontWeight: "normal" }}>{t('labels.result')}</Divider>
            </Col>
            <Col span={24}>
                <Statistic 
                  style={{textAlign: "center"}} 
                  title={t('labels.furnace.recommended_time')} 
                  value={recommendation && recommendation.furnace_time && secons2Dhm(recommendation.furnace_time)} 
                  suffix={"D hh:mm"} 
                  prefix={<Icon type="clock-circle" />}
                />
            </Col>
            <Col span={24}>{furnaceErr && <Alert message={t('alerts.warning')} description={furnaceErr} type="warning" showIcon />}</Col>
          </Card>
        </Spin>
      </Col>

      <Col xl={8} lg={24}>
        <Spin spinning={isSubmittingKirkaldy}>
          <Card title={t('phase.quenching')}>
            <Col span={24}>
              <RenderData label={t('labels.quenching.bath_type.text')} value={t('labels.quenching.bath_type.'+process.quenching.bath_type)} />
            </Col>
            <Col span={24}>
              <RenderData label={t('labels.quenching.bath_temp')} value={process.quenching.bath_temperature} unit="ºC" />
            </Col>
            <Col span={24}>
              <RenderData
                label={t('labels.quenching.agitation_level')}
                value={marksAgitation[process.quenching.agitation_level]}
                unit={process.quenching.agitation_level === 0 ? "" : "m/s"}
              />
            </Col>
            <Col span={24}>
              <Divider style={{ fontSize: 12, fontWeight: "normal" }}>{t('labels.result')}</Divider>
            </Col>
            <Col span={12}>
              {/*<RenderData label="Capa requerida" value={article.hard_coat} unit="mm" />*/}
              <Statistic style={{textAlign: "center"}} precision={2} title={t('labels.quenching.specified_coat')} value={article.hard_coat} suffix={"mm"} />
            </Col>
            <Col span={12}>
              {/*<RenderData label="Capa obtenida del temple" value={recommendation && recommendation.quenching} unit="mm" />*/}
              <Statistic 
                style={{textAlign: "center"}} 
                precision={2} 
                valueStyle={{ color: recommendation && recommendation.quenching >= article.hard_coat ? colors.success : colors.danger }} 
                title={t('labels.quenching.obtained_coat')}
                value={recommendation && recommendation.quenching} 
                suffix={"mm"} 
                prefix={ recommendation && recommendation.quenching >= article.hard_coat ? <Icon type="check" /> : <Icon type="warning" />}
              />
            </Col>
            <Col span={24}>{quenchingErr && <Alert message={t('alerts.warning')} description={quenchingErr} type="warning" showIcon />}</Col>
          </Card>
        </Spin>
      </Col>
      <Col xl={8} lg={24}>
        <Spin spinning={isSubmittingTempered}>
          <Card title={t('phase.tempered')}>
          <Col span={24}>
            <RenderData label={t('labels.furnace.furnace_temp')} value={process.tempered.temperature} unit="ºC" />
          </Col>
          <Col span={24}>
            {process.tempered.enabled_ramp ? (
              <RenderData label={t('labels.furnace.heating_ramp')} value={process.tempered.heating_ramp} unit="ºC/h" />
            ) : (
              <RenderData label={t('labels.furnace.heating_ramp')} value={t('labels.no_ramp')} />
            )}
          </Col>
          <Col span={24}>
            <RenderData label={t('labels.hardness_required')} value={article.hardness_required} unit="HV1" />
          </Col>
          <Col span={24}>
            <Divider style={{ fontSize: 12, fontWeight: "normal" }}>{t('labels.result')}</Divider>
          </Col>  
          <Col span={24}>
            <Statistic 
              style={{textAlign: "center"}} 
              title={t('labels.furnace.recommended_time')} 
              value={recommendation && recommendation.tempered_time && secons2Dhm(recommendation.tempered_time)} 
              suffix={ "D hh:mm" } 
              prefix={<Icon type="clock-circle" />}
            />
          </Col>
          <Col span={24}>{temperedErr && <Alert message={t('alerts.warning')} description={temperedErr} type="warning" showIcon />}</Col>
        </Card>
        </Spin>
      </Col>
    </Row>
  );
};

export default Recommendations;
